var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocalization = function SvgLocalization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M32 46c-7.732 0-14-6.268-14-14s6.268-14 14-14 14 6.268 14 14-6.268 14-14 14zM19 33v-2h26v2H19zm13 11c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12zm0 0c.62 0 1.567-.934 2.404-2.888C35.41 38.768 36 35.506 36 32c0-3.506-.591-6.768-1.596-9.112C33.567 20.934 32.62 20 32 20c-.62 0-1.567.934-2.404 2.888C28.59 25.232 28 28.494 28 32c0 3.506.591 6.768 1.596 9.112C30.433 43.066 31.38 44 32 44zm0 2c-3.314 0-6-6.268-6-14s2.686-14 6-14 6 6.268 6 14-2.686 14-6 14z"
  })));
};
export default SvgLocalization;